import React from 'react';

export const ArrowLeftIcon = () => {
  return <div data-testid="arrow-left-icon-id" className="vbz-icon-corporates-club-arrow-left" />;
};
